import { BaseWidget } from './BaseWidget.js';

export class TabWidget extends BaseWidget {
	constructor(options) {
		super({ ...options, type: 'tab' });
	}

	_render() {
		const tab = document.createElement('div');
		tab.className = `feedback-widget feedback-widget-tab position-${this.options.position}`;
		tab.innerHTML = `
      <div class="feedback-tab-trigger">
        <span class="feedback-tab-text">Feedback</span>
      </div>
    `;

		if (this.options.customStyles) {
			Object.assign(tab.style, this.options.customStyles);
		}

		return tab;
	}

	_attachEvents() {
		const tab = this.element.querySelector('.feedback-tab-trigger');
		tab.addEventListener('click', this.openModal);
	}

	updateText(text) {
		const textElement = this.element?.querySelector('.feedback-tab-text');
		if (textElement) {
			textElement.textContent = text;
		}
	}

	updatePosition(position) {
		this.options.position = position;
		if (this.element) {
			this.element.className = this.element.className.replace(
				/position-\w+-\w+/,
				`position-${position}`
			);
		}
	}
}
